/**
 * Valores iniciais do formulário de Class/Turma.
 */
export const classDefaults = {
    idActivity: "",
    idEmployee: "",
    idArea: "",
    classGroupId: "", // Agrupa turmas criadas juntas (Seg/Qua/Sex = mesmo grupo)
    weekdays: [],
    startTime: "",
    durationMinutes: "",
    endTime: "",
    maxCapacity: "",
    startDate: "",
    endDate: "",
};
